/**
 * Whether the cart holds a licence-restricted product (e.g. a pesticide) — the gate for the
 * restricted-items "Attention" checkout modal (`confirmRestrictedItems` in cart-functions.ts).
 * DOM-free on purpose so it can be unit-tested; cart-functions.ts imports it.
 *
 * Reads `product.restricted` from the cart JSON, which carries each item's full product. The
 * server makes the same check before letting /checkout through (CheckoutController.index).
 */
export function cartHasRestrictedItems(cartData: any): boolean {
  return Object.values(cartData?.cart?.items ?? {}).some((item: any) => item?.product?.restricted === true);
}
